const ora = require('ora'); 
import { injectable } from "inversify";
import * as inquirer from "@porketta.io/inquirer";

/**
 * Expose methods to interact with the console
 */
export interface ConsoleUI {

    /**
     * Prompt a spinning loader
     * @param message
     */
    loaderStart(message: string): void;

    /**
     * Stop a running loader with a failure message
     * @param message
     */
    loaderFail(message: string): void;

    /**
     * Stop a running loader with a success message
     * @param message
     */
    loaderSuccess(message: string): void;

    /**
     * Log a message.
     * If a spinning is running, update its text
     * @param message
     */
    log(message: any): void;

    promptList(message: string, choices: any[]): Promise<any>;

    promptInput(message: string): Promise<string>;

    promptConfirm(message: string): Promise<boolean>;

    promptCheckbox(message: string, choices: any[]): Promise<string>;

}

@injectable()
export class ConsoleImplUno implements ConsoleUI {

    private spinner = new ora();

    loaderFail(message: string): void {
        this.spinner.fail(message);
    }

    loaderStart(message: string): void {
        this.spinner.start(message);
    }

    loaderSuccess(message: string): void {
        this.spinner.succeed(message);
    }

    log(message: any): void {

        if(typeof message !== "string") {
            message = JSON.stringify(message, null, 4);
        }

        if(this.spinner.isSpinning) {
            this.spinner.text = message;
        }
        else {
            console.log(message);
        }
    }



    promptList(message: string, choices: any[]): Promise<any> {
        if(this.spinner.isSpinning) {
            this.spinner.stop();
        }
        return inquirer.prompt([{ type: 'list', name: 'result', message, choices }]).then(res => {
            return res["result"];
        });
    }

    promptInput(message: string): Promise<string> {
        if(this.spinner.isSpinning) {
            this.spinner.stop();
        }
        return inquirer.prompt([{ type: 'input', name: 'result', message}]).then(res => {
            return res["result"];
        });
    }

    promptCheckbox(message: string, choices: any[]): Promise<string> {
        if(this.spinner.isSpinning) {
            this.spinner.stop();
        }

        return inquirer.prompt([{ type: 'checkbox', name: 'results', message , choices }]).then(res => {
            return res["results"];
        });
    }

    promptConfirm(message: string): Promise<boolean> {
        if(this.spinner.isSpinning) {
            this.spinner.stop();
        }

        return inquirer.prompt([{ type: 'confirm', name: 'confirm', message }]).then(res => {
            return res["confirm"];
        });
    }

}